import { Link } from "react-router-dom";
import ServiceLayout, { ContentSection } from "@/components/site/ServiceLayout";
import { Reveal, TickList } from "@/components/site/Reveal";

const REASONS = [
  "Communication breakdown",
  "Emotional disconnection",
  "Rebuilding trust after infidelity",
  "Recurring conflict",
  "Parenting disagreements",
  "Intimacy or sexual concerns",
  "Blended-family challenges",
  "Preparing for separation",
  "Strengthening an otherwise healthy relationship",
];

const SESSIONS = [
  "Sessions for both partners together, with individual sessions where helpful",
  "A structured, balanced space where both people are heard",
  "Practical work on communication, conflict and connection",
  "Clear goals agreed together and reviewed as you go",
];

export default function CouplesCounselling() {
  return (
    <ServiceLayout
      eyebrow="Services"
      title="Couples Counselling"
      lead="A supportive, structured space for couples who want to understand each other again — whether you are in crisis or simply drifting apart."
      image="https://images.unsplash.com/photo-1512716679859-da19b4af9c38?crop=entropy&cs=srgb&fm=jpg&q=85"
      imageAlt="Two cups of tea on a quiet table"
    >
      <ContentSection eyebrow="Who this is for" title="Common reasons couples attend">
        <TickList items={REASONS} />
      </ContentSection>

      <ContentSection eyebrow="What sessions involve" title="A balanced, structured process" pale>
        <TickList items={SESSIONS} columns={1} />
      </ContentSection>

      <ContentSection eyebrow="Suitability & safety" title="When couples counselling may not be appropriate">
        <Reveal>
          <div className="max-w-3xl rounded-2xl border border-euca-line bg-white p-7 sm:p-8" data-testid="couples-safety-note">
            <p className="text-base leading-relaxed text-charcoal/85">
              Couples counselling may not be appropriate where there is coercive control, current family violence,
              or where either partner is unable to participate safely. In these situations we will talk with you
              about more suitable, individual support options.
            </p>
            <p className="mt-4 text-sm leading-relaxed text-mutedsoft">
              If you are experiencing family or domestic violence, confidential support is available 24/7 through{" "}
              <span className="font-semibold text-charcoal">1800RESPECT — 1800 737 732</span>.
            </p>
          </div>
        </Reveal>
      </ContentSection>

      <ContentSection eyebrow="Fees" title="Fees and bookings" pale>
        <Reveal>
          <p className="max-w-3xl text-base leading-relaxed text-mutedsoft">
            Couples counselling is usually privately funded. Current session fees are confirmed at the time of
            enquiry — see{" "}
            <Link to="/fees-funding" className="font-semibold text-euca hover:underline" data-testid="couples-fees-link">
              Fees &amp; Funding
            </Link>{" "}
            or send an enquiry and we will explain the costs before you book.
          </p>
        </Reveal>
      </ContentSection>
    </ServiceLayout>
  );
}
